// =============================================================================
// Admin Analytics — a single widget's error state
// =============================================================================
// Each widget fails on its own: if its slice of the dashboard can't load, it
// shows this in place of its content while every other widget keeps rendering.
// =============================================================================
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export const CellErrorState: React.FC<{ onRetry?: () => void; message?: string }> = ({
  onRetry,
  message = "Couldn't load this widget.",
}) => (
  <div role="alert" className="flex flex-col items-center justify-center gap-1.5 py-4 text-center">
    <ExclamationTriangleIcon className="h-5 w-5 text-limestone-400" />
    <span className="text-xs text-text-secondary">{message}</span>
    {onRetry && (
      <button type="button" onClick={onRetry} className="text-xs font-medium text-text-primary hover:underline">
        Try again
      </button>
    )}
  </div>
);
